import { supabase } from '../../adapters/database/supabaseClient'
import type { ManagedOrder } from './types'
import { eventDayUtcBounds } from './orderHistoryDate'

/** Fetch a selected event day with server-side UTC boundaries, paginating to avoid PostgREST's default 1,000-row cap. */
export async function listManagedOrders(eventId:string,day:string|null=null):Promise<ManagedOrder[]>{
 const bounds=day?eventDayUtcBounds(day):null
 const rows:any[]=[]
 const size=500
 for(let offset=0;offset<10000;offset+=size){
  let query=supabase.from('orders').select(`id,event_id,number,status,source,total_cents,created_at,cancelled_at,cancellation_reason,customer_name,service_location,payments(method,status,provider,paid_at,updated_at),order_items(id,product_name,quantity,unit_price_cents,line_total_cents,sort_order,note,event_departments(name),order_item_variants(variant_name))`).eq('event_id',eventId)
  if(bounds)query=query.gte('created_at',bounds.from).lt('created_at',bounds.until)
  const {data,error}=await query.order('created_at',{ascending:false}).range(offset,offset+size-1)
  if(error)throw error
  const chunk=data??[]
  rows.push(...chunk)
  if(chunk.length<size)break
 }
 return rows.map((row:any)=>{
  const payments=[...(row.payments??[])].sort((a:any,b:any)=>{
    const priority=(p:any)=>p.status==='paid'?2:p.status==='pending'?1:0
    return priority(b)-priority(a)||new Date(b.updated_at).getTime()-new Date(a.updated_at).getTime()
  })
  const selected=payments[0]??null
  return {
   id:row.id,eventId:row.event_id,number:Number(row.number),status:row.status,
   source:row.source,totalCents:row.total_cents,createdAt:row.created_at,
   cancelledAt:row.cancelled_at,cancellationReason:row.cancellation_reason,
   paymentMethod:selected?.method??null,paymentProvider:selected?.provider??null,
   paymentStatus:selected?.status??null,customerName:row.customer_name??null,
   serviceLocation:row.service_location??null,
   lines:[...(row.order_items??[])].sort((a:any,b:any)=>a.sort_order-b.sort_order)
    .map((item:any)=>({
      id:item.id,productName:item.product_name,quantity:item.quantity,
      unitPriceCents:item.unit_price_cents,lineTotalCents:item.line_total_cents,
      departmentName:item.event_departments?.name??null,note:item.note??null,
      variants:(item.order_item_variants??[]).map((v:any)=>v.variant_name)
    }))
  }
 })
}
export async function reprintManagedOrder(orderId:string,scope:'cashier'|'all'):Promise<number>{
 const {data,error}=await supabase.rpc('reprint_managed_order',{
  target_order_id:orderId,target_scope:scope,target_request_id:crypto.randomUUID()
 })
 if(error)throw error
 const result=data as {ok?:boolean;jobsCreated?:number}|null
 if(!result?.ok||!result.jobsCreated)throw new Error('Nessuno scontrino ristampato')
 return Number(result.jobsCreated)
}
export async function cancelManagedOrder(orderId:string,reason:string):Promise<void>{
 const{error}=await supabase.rpc('cancel_order',{target_order_id:orderId,target_reason:reason.trim()||null})
 if(error)throw error
}
export async function captureCustomerCashPayment(orderId:string):Promise<void>{
 const{error}=await supabase.rpc('capture_customer_cash_payment',{target_order_id:orderId})
 if(error)throw error
}
